import { VIEW_GUEST_FAILURE, VIEW_GUEST_REQUEST, VIEW_GUEST_SUCCESS, ViewGuestActionTypes, ViewGuestState } from './types';

const defaultState: ViewGuestState = {
  isLoading: false,
  errorMessage: '',
};

export default function viewGuest(state = defaultState, action: ViewGuestActionTypes): ViewGuestState {
  switch (action.type) {
    case VIEW_GUEST_REQUEST:
      return { ...state, isLoading: true };
    case VIEW_GUEST_SUCCESS:
      return { ...state, contents: action.contents, isLoading: false, errorMessage: '' };
    case VIEW_GUEST_FAILURE:
      return { ...state, isLoading: false, errorMessage: '' };
    default:
      return state;
  }
}
